// @flow

// React Router
import { push } from 'react-router-redux'

// Effect Managers
import { put, take, select, race } from 'redux-saga/effects'

// Selectors
import { activeRoute$ } from 'hfty-navigation-web'

// Constants
import { SELECT_SOIL_JOB } from 'hfty-soil-jobs-dom/src/constants'
import {
  MAP_ROUTE_JOBS_TAB,
  CLEAR_MAP_URL_FROM_JOB_ID,
} from 'hfty-map-dom/src/constants'

export default function *setJobUrl (): Generator<*, *, *> {
  while (true) {
    const { selectedJob } = yield race({
      clear: take(CLEAR_MAP_URL_FROM_JOB_ID),
      selectedJob: take(SELECT_SOIL_JOB),
    })
    const path = yield select(activeRoute$)
    let jobId = null

    if (selectedJob) {
      jobId = selectedJob.payload
    }

    if (path.includes(MAP_ROUTE_JOBS_TAB)) {
      yield put(push(`${MAP_ROUTE_JOBS_TAB}/${jobId || ''}`))
    }
  }
}
